import React from 'react';
import block from 'bem-cn-lite';
import {HTML} from '@doc-tools/components';
import {CardBase, Links, YFMWrapper} from '@yandex-data-ui/page-constructor';

import withTranslation, {WithTranslationProps} from 'hoc/withTranslation';
import {CardProps as CardParams} from 'units/constructor-local/models';
import ServiceLabel from '../ServiceLabel/ServiceLabel';

import './Card.scss';

const b = block('card-block');

type CardProps = CardParams & WithTranslationProps;

const Card: React.FC<CardProps> = (props) => {
    const {
        text,
        header: {image, title: headerTitle} = {},
        link,
        links = [],
        service,
        border,
        children,
        i18nK,
    } = props;

    return (
        <CardBase className={b()} border={border}>
            <CardBase.Header image={image} className={b('header')}>
                {headerTitle && (
                    <h4 className={b('title')}>
                        <HTML>{headerTitle}</HTML>
                    </h4>
                )}
            </CardBase.Header>
            <CardBase.Content>
                {text && (
                    <YFMWrapper
                        content={text}
                        modifiers={{
                            constructor: true,
                            constructorListStyle: true,
                        }}
                    />
                )}
                {children}
                {service && (
                    <div className={b('service')}>
                        <span className={b('service-phrase')}>
                            {i18nK('constructor_service_chain')}
                        </span>
                        <a href={`/services/${service.slug}`}>
                            <ServiceLabel
                                className={b('service-label')}
                                {...service}
                                size="s"
                                inline={true}
                            />
                        </a>
                    </div>
                )}
            </CardBase.Content>
            <CardBase.Footer>
                <Links links={[...(link ? [link] : []), ...links]} />
            </CardBase.Footer>
        </CardBase>
    );
};

export default withTranslation('constructor')(Card);
